import { useRef } from 'react';

export const useChecklistItemInput = () => {
    const modalTitleRef = useRef<HTMLTextAreaElement>(null);

    const blurModalTitle = () => {
        modalTitleRef.current?.blur();
    };

    return {
        ref: modalTitleRef,
        blurModalTitle,
    };
};
